







































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { getUserFullName } from '@/helpers/functions';
import {
  IContractor,
  ICompanyType,
  IBankAttribute,
  ICRUDResponse,
} from '../../models';
import { client } from '@/store';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'contractor';
const ns = { namespace };

const asDict = (arr: any[]) =>
  arr.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});

@Component({
  methods: {
    getUserFullName,
  },
})
export default class ContractorDetail extends BaseDetail<IContractor> {
  namespace = namespace;
  representatives = [];
  @State('entities', ns) entities: Record<string, IContractor>;
  @State('entities', { namespace: 'companyType' }) companyTypes: ICompanyType[];
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  attributes: Record<string, IBankAttribute> = {};
  mounted() {
    this.loadEntity()?.then(() => {
      this.setValue(this.entityPatch, 'id', Number(this.entityId));
    });
    if (Number(this.entityId)) {
      this.getEntity(this.entityId).then(() => {
        client
          .get<ICRUDResponse<IBankAttribute[]>>('bank_attributes')
          .then(({ data }) => {
            this.attributes = asDict(data.data);
            const entity = this.entityId
              ? this.entities[this.entityId]
              : undefined;
            if (entity) {
              for (const {
                id,
                pivot: { value },
              } of entity.bank_attributes!) {
                this.setValue(this.attributes[id], 'value', value);
              }
            }
          });
      });
    } else {
      client
        .get<ICRUDResponse<IBankAttribute[]>>('bank_attributes')
        .then(({ data }) => {
          this.attributes = asDict(data.data);
        });
    }
  }
  get entity() {
    const { bank_attributes, ...base } = this.baseEntity;
    return {
      ...base,
      ...this.entityPatch,
      bank_attributes: Object.values(this.attributes),
    };
  }
  removeRepresentatives(index: number) {
    this.entityPatch.representatives?.splice(index, 1);
  }
  created() {
    client
      .get('/representative')
      .then(({ data }) => (this.representatives = data));
  }
}
